var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather03D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-03d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-03d",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5957673,41.7866961 C40.9460379,43.1682664 38.8201499,44 36.5,44 C34.2383018,44 32.1612006,43.2096463 30.52982,41.8900625 C28.7920918,43.8006439 26.2861082,45 23.5,45 C20.2213734,45 17.3306641,43.3391282 15.6233319,40.8128443 C14.2406266,41.571195 12.6680051,42 11,42 C5.4771525,42 1,37.2989899 1,31.5 C1,26.3123293 4.58296017,22.0033461 9.2922561,21.152506 C10.3372604,17.0411421 14.0634818,14 18.5,14 C20.4869426,14 22.3314144,14.6099902 23.8563644,15.6529196 C26.5050218,12.7913837 30.2933109,11 34.5,11 C41.3213409,11 47.0425355,15.7102861 48.5884592,22.0557337 C53.8759998,22.6003041 58,27.0685461 58,32.5 C58,38.2989899 53.2989899,43 47.5,43 C45.7285644,43 44.0595855,42.5613307 42.5957673,41.7866961 Z",
    id: "Combined-Shape-Copy-3",
    stroke: "#0A6EAC",
    fill: "#59A5D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather03D);
export default __webpack_public_path__ + "static/media/icon-weather-03d.dd72fdb15de363c25798655a424521a2.svg";
export { ForwardRef as ReactComponent };